import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  modules: [],
  loading: false,
  error: null
};

const modulesSlice = createSlice({
  name: 'modules',
  initialState,
  reducers: {
    setModules: (state, action) => {
      state.modules = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    }
  }
});

export const { setModules, setLoading, setError } = modulesSlice.actions;
export default modulesSlice.reducer;
